import styled from 'styled-components';
import { palette } from 'styled-tools';

import { Button, fontWeight, FontWeights, minWidth } from '@calm-web/design-system';

export const Wrapper = styled.div`
	background: ${palette('white')};
	bottom: 0;
	color: ${palette('gray8')};
	left: 0;
	position: fixed;
	top: 0;
	padding-top: 96px;
	right: 0;
	text-align: center;
	z-index: 99;
`;

export const ContentContainer = styled.div`
	${minWidth('tablet')} {
		grid-column: 2 / 4;
	}
`;

export const Heading = styled.h4`
	border-bottom: 1px ${palette('gray2')} solid;
	${fontWeight(FontWeights.Regular)}
	margin-bottom: 40px;
	padding-bottom: 24px;
`;

export const BodyText = styled.p`
	margin-bottom: 40px;
`;

export const ButtonWithMargin = styled(Button)`
	margin-bottom: 8px;
`;
